import React from 'react';
import { ColorRowHeader } from './styles';

const ColorRowHeaderWrapper = () => (
  <ColorRowHeader>
    <div className="row-header">
      <div className="row-header__title">
        <h2 className="sui-h2-bold sui-line-clamp-unset sui-text-primary">Colors</h2>
      </div>
    </div>
  </ColorRowHeader>
);

export default ColorRowHeaderWrapper;
